/**
 * Публичный лендинг. Платёжное окно уводит сюда, а не в кабинет (`/`).
 * То же значение, что у логотипа в `layouts/payment.vue`.
 */
export const PAYMENT_LANDING_URL = 'https://goodpayments.ru/'

/**
 * Возвращает базовый URL приложения (origin) для построения абсолютных ссылок.
 * На клиенте — window.location.origin, на сервере — из useRequestURL() при доступности.
 */
export function getBaseUrl(): string {
  if (process.client && typeof window !== 'undefined' && window.location) {
    return window.location.origin
  }
  if (process.server) {
    try {
      const requestURL = useRequestURL()
      return `${requestURL.protocol}//${requestURL.host}`
    } catch {
      return ''
    }
  }
  return ''
}
